import type { AdminOverview, AdminUserRow, MeView, ProgressView } from '@gc/shared';
import { initData } from './telegram.js';

/**
 * Вне Telegram подписи initData нет и сервер обоснованно отвечает 401.
 * Чтобы вёрстку можно было смотреть в обычном браузере, в режиме разработки
 * подставляем демо-данные. В продакшен-сборку эта ветка не попадает.
 */
async function mocked<T>(path: string): Promise<T | null> {
  if (!import.meta.env.DEV || initData()) return null;
  const { mockMe, mockOverview, mockUsers } = await import('./mock.js');
  if (path === '/me') return mockMe() as T;
  if (path === '/admin/overview') return mockOverview() as T;
  if (path === '/admin/users') return mockUsers() as T;
  return null;
}

async function call<T>(path: string, body?: unknown): Promise<T> {
  const demo = await mocked<T>(path);
  if (demo) return demo;

  const res = await fetch(`/api${path}`, {
    method: body === undefined ? 'GET' : 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Подписанная строка Telegram — единственное удостоверение личности.
      'X-Init-Data': initData(),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  if (!res.ok) {
    const text = await res.text();
    let message = `Ошибка ${res.status}`;
    try {
      message = (JSON.parse(text) as { error?: string }).error ?? message;
    } catch {
      /* тело не JSON — оставляем код статуса */
    }
    throw new Error(message);
  }
  return (await res.json()) as T;
}

export const api = {
  me: () => call<MeView>('/me'),
  complete: (day: number, done = true) =>
    call<{ progress: ProgressView }>('/complete', { day, done }),
  setReminder: (reminderHour: number) =>
    call<{ reminderHour: number }>('/settings', { reminderHour }),
  adminOverview: () => call<AdminOverview>('/admin/overview'),
  adminUsers: () => call<AdminUserRow[]>('/admin/users'),
};
